// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1136":"3f2f562d","5054":"27bf86ea","5491":"82a856de"}[chunkId] + ".chunk.css";
};